module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Therm Check - pomiar temperatury bezdotykowy i szybki","short_name":"Pomiar temperatury bezdotykowy i szybki","description":"Szybki i bezdotykowy pomiar temperatury. Niezawodne wykrywanie stanów gorączkowych na skalę przemysłową.","lang":"pl","display":"standalone","icon":"src/assets/images/icon.png","start_url":"/","prefer_related_applications":true,"background_color":"#d60040","theme_color":"#d60040","crossOrigin":"use-credentials","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"4abcba3992c82ad6ec14b498d4178367"},
    },{
      plugin: require('../node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false,"disableVendorPrefixes":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-fontawesome-css/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
